// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip_card {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 46px;
  height: 20px;
  bottom: 8px;
  left: 6px;
  border-radius: 9px;
  background-color: rgba(38, 38, 38, 0.1882352941);
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/TipCount/index.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,gDAAA;EACA,cAAA;AACJ","sourcesContent":[".tip_card {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    width: 46px;\n    height: 20px;\n    bottom: 8px;\n    left: 6px;\n    border-radius: 9px;\n    background-color: #26262630;\n    padding: 0 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
